/**
 * App-wide text-zoom (accessibility comfort control).
 *
 * Scales the whole document via the `zoom` CSS property so the brand's many
 * fixed-px font sizes scale too (a root font-size change would only affect
 * rem-based text). Three levels: 100% / 112% / 125%.
 *
 * Persisted under localStorage "ekselens.textZoom" (functional preference,
 * no tracking). Defensive: a disabled/quota-full localStorage degrades to the
 * default 100% without throwing.
 */
const KEY = "ekselens.textZoom";
export const ZOOM_LEVELS = [1, 1.125, 1.25];

export const getZoom = () => {
  try {
    const v = parseFloat(window.localStorage.getItem(KEY));
    return ZOOM_LEVELS.includes(v) ? v : 1;
  } catch (e) {
    if (typeof console !== "undefined") console.warn("[textZoom] get failed:", e);
    return 1;
  }
};

export const applyZoom = (z) => {
  try { document.body.style.zoom = String(z); } catch (e) {
    if (typeof console !== "undefined") console.warn("[textZoom] apply failed:", e);
  }
};

export const setZoom = (z) => {
  const level = ZOOM_LEVELS.includes(z) ? z : 1;
  try { window.localStorage.setItem(KEY, String(level)); } catch (e) {
    if (typeof console !== "undefined") console.warn("[textZoom] set failed:", e);
  }
  applyZoom(level);
  try { window.dispatchEvent(new CustomEvent("ek-text-zoom-change", { detail: level })); } catch {/*noop*/}
  return level;
};

/** Bootstrap on app load — re-apply the visitor's stored zoom level. */
export const initTextZoom = () => applyZoom(getZoom());
